export default __webpack_public_path__ + "static/resources/policy/Стратегия_управления_персоналом_Акваарт_+.doc";